import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Founders = () => {
  const [founders, setFounders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFounders = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API}/profiles?type=founder`);
        setFounders(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching founders:', err);
        setError('Failed to load founders. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchFounders();
  }, []);

  if (loading) {
    return (
      <div className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="display-large">Our Founders</h1>
            <p className="body-large">Loading...</p>
          </div>
        </section>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="display-large">Our Founders</h1>
            <p className="body-large error-message">{error}</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1 className="display-large">Our Founders</h1>
          <p className="body-large">Leadership and vision behind Pacific Ghost Baseball</p>
        </div>
      </section>

      <section className="profiles-section">
        <div className="container">
          {founders.length === 0 ? (
            <p className="body-large" style={{ textAlign: 'center' }}>Founder information coming soon.</p>
          ) : (
            <div className="profiles-grid">
              {founders.map((founder) => (
                <div key={founder.id} className="profile-card network-card">
                  <div className="profile-photo">
                    <img src={founder.photo_url} alt={founder.name} />
                  </div>
                  <div className="profile-info">
                    <h3 className="network-card-title">{founder.name}</h3>
                    <p className="profile-title">{founder.title}</p>
                    <p className="network-card-content">{founder.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Founders;